module.exports = __webpack_public_path__ + "assets/img/main5.5e9500b1.png";